import { ACTION, SCREEN } from '../constants/mixpanel';

import useFeatureFlags from 'shared/modules/common/hooks/use-feature-flags';
import Mixpanel from 'shared/vendor/Mixpanel';

const FEATURE_NAME = 'feature.web-ekyc';

export default function useIsWebEKYCEnabled() {
  const data = useFeatureFlags({
    onError: (error) => {
      Mixpanel.trackEvent(`${SCREEN.BROWSE} - ${ACTION.ERROR}`, {
        Error: error.message.toLowerCase(),
      });
    },
  });

  if (!data) {
    // Sending null values means API haven't completed
    return null;
  } else {
    return data.features.enabled.indexOf(FEATURE_NAME) > -1;
  }
}
